import React from 'react'
import CardTitle from 'src/components/sharedComponents/CardTitle'
import PolygonsTable from 'src/components/sharedComponents/Tablas'

const ConsolidatedPage = (props) => {
  const { dataTable, permits } = props

  const columns = [
    { title: 'Color', field: 'color' },
    { title: 'Gerente', field: 'gerente' },
    { title: 'Jefe', field: 'jefe' },
    { title: 'Territorio', field: 'territorio' },
    { title: 'Zona', field: 'zona' },
    { title: 'Departamento', field: 'departamento' },
    { title: 'Municipio', field: 'municipio' },
  ]
  return (
    <>
      <CardTitle title="Consolidado" />
      <PolygonsTable
        columns={columns}
        dataTable={dataTable}
        idPermisoTabla={permits}
        titleTable="Consolidado"
        hiddenEdit
        hiddenDelete
        hiddenActions={false}
      />
    </>
  )
}

export default ConsolidatedPage
